import { render, staticRenderFns } from "./MasterCardIcon.vue?vue&type=template&id=0b05d417&"
import script from "./MasterCardIcon.vue?vue&type=script&lang=ts&"
export * from "./MasterCardIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports